import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';

import AboutData from './AboutData';
import FaqData from './FaqData';
import PolicyCostData from './PolicyCostData';
import PurchasingProcessData from './PurchasingProcessData';
import ProductCarriers from './ProductCarriers';
import FinalExpenseArticleData from './FinalExpenseArticleData';
import FinalExpenseAboutMeForm from '../../../../Quoters/FinalExpense/steps/AboutMeForm';
import { getPrimaryColor } from '../../../../Quoters/Common/Helpers/Utility';

export default function FinalExpenseData(props) {
  const primaryBrandColor = getPrimaryColor();
  const minAge = 50;
  const maxAge = 85;
  const minCoverageAmount = 2000;
  const maxCoverageAmount = 50000;
  
  const navigate = useNavigate();
  const location = useLocation();
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  const accountProductTypeSettings = accountObj.accountProducts.find(product => product.productLandingUrl === location.pathname);
  const accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ?
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

  const finalExpenseForm = (<FinalExpenseAboutMeForm
    ageSpecs={{ min: minAge, max: maxAge }}
    onNext={() => {
      navigate('/final-expense/quote-results');
    }}
    brandTheme={primaryBrandColor}
    showHeader={false}
    submitButtonVariant={'landing'}
    isFinalExpense={props.isFinalExpense}
    ref={props.aboutMeFormRef}
  />);

  const defaultValueProposition = [{
    title: " Final Expense Insurance",
    subtitle: "Guaranteed Simple Protection",
    subtitleExtended: "Secure your loved ones with affordable, quality Final Expense Life Insurance - easy application and guaranteed approval.",
  }];

  return {
    name: 'Final Expense Insurance',
    subtitle: 'Guaranteed Simple Protection',
    footerMessage: "Get peace of mind and final expense insurance",
    footerButtonName: "CONTINUE",
    heroText: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : defaultValueProposition,
    specs: {
      age: {min: minAge, max: maxAge},
      coverageAmount: {min: minCoverageAmount, max: maxCoverageAmount},
    },
    basicInfoForm: () => {
      return finalExpenseForm;
    },
    about: AboutData(minAge, maxAge, minCoverageAmount, maxCoverageAmount),
    purchasingProcess: PurchasingProcessData(),
    policyCost: PolicyCostData(),
    faq: FaqData(),
    termArticle: FinalExpenseArticleData(),
    productCarriers: ProductCarriers(),
    isAddDefaultFaq: false,
  };
}
